import es, { TranslationKey } from './es'
import en from './en'
import zh from './zh'

export type Lang = 'es' | 'en' | 'zh'

export const LANGS: { code: Lang; label: string }[] = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
  { code: 'zh', label: '中文' },
]

const dicts: Record<Lang, Record<TranslationKey, string>> = { es, en, zh }

export function translate(lang: Lang, key: TranslationKey, vars?: Record<string, string | number>): string {
  let s: string = dicts[lang][key] ?? es[key] ?? key
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.split(`{${k}}`).join(String(v))
    }
  }
  return s
}

export { es, en, zh }
export type { TranslationKey }
